import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './ActivityStatusEditor.html?raw';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import Edit from '../../../moreCore/UI/Edit/Edit';
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";

class ActivityStatusEditor extends compose(MainCatalogsEditorBase) {

    templateString: any = template;

    as_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    as_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    as_Input_Description_Multi_Lang: MdsLax<InstanceType<typeof MultiLangEdit<MainCatalogTypes.EvActivityStatus_LoadData>>>;
    as_Input_StatusGroup: MdsLax<InstanceType<typeof SearchSelect>>;
    as_Input_TextColor: HTMLInputElement;
    as_Input_BackgroundColor: HTMLInputElement;
    as_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    //as_Checkbox_GeneratingAutoCostUnit: CheckBox = new CheckBox();
    as_Checkbox_WithPublic: MdsLax<InstanceType<typeof CheckBox>>;
    as_Checkbox_ToPublishInWeb: MdsLax<InstanceType<typeof CheckBox>>;
    //as_Checkbox_ToPublishInEgo: CheckBox = new CheckBox();
    as_Checkbox_Event: MdsLax<InstanceType<typeof CheckBox>>;
    as_Checkbox_ImportToCommdoc: MdsLax<InstanceType<typeof CheckBox>>;
    //as_Checkbox_Employment: CheckBox = new CheckBox();


    formData: MainCatalogTypes.EvActivityStatus_SaveData = {
        ID: "",
        is_new_status: null,
        code: "",
        description: "",
        ev_activity_status_group_id: "",
        //is_generating_auto_cost_unit: null,
        is_with_public: null,
        is_to_publish_in_web: null,
        //is_to_publish_in_ego: null,
        is_event: null,
        is_import_to_commdoc: null,
        //is_employment: null,
        order: null,
        coloration: null,
        __multilang: { }
    };

    prepareFormData(data?: MainCatalogTypes.EvActivityStatus_LoadData): void {      
        let statusId: string = null;

        if (data) {

            this.as_Input_Code.setValue(data.code, true);
            //this.as_Input_Description.setValue(data.description_D, true);
            //Tesing purpose - Should make api call and set data with return value
            this.as_Input_Description_Multi_Lang.setValue({ entity: data, targetAttribute: "description" } , true);

            this.as_Input_StatusGroup.loadListValues(data.ref_ev_activity_status_group.ID, true);
            statusId = data.ref_ev_activity_status_group.ID;
            //this.UiModder.domClass.add(this.as_Input_StatusGroup.scrollContainer, "w3-2018-coconut-milk");

            this.as_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.as_Input_BackgroundColor.value = data.coloration.BackColor.Hex;
            this.as_Input_Order.setValue(data.order, true);

            //this.as_Checkbox_GeneratingAutoCostUnit.setValue(data.is_generating_auto_cost_unit, true);
            this.as_Checkbox_WithPublic.setValue(data.is_with_public, true);
            this.as_Checkbox_ToPublishInWeb.setValue(data.is_to_publish_in_web, true);
            //this.as_Checkbox_ToPublishInEgo.setValue(data.is_to_publish_in_ego, true);
            this.as_Checkbox_Event.setValue(data.is_event, true);
            this.as_Checkbox_ImportToCommdoc.setValue(data.is_import_to_commdoc, true);
            //this.as_Checkbox_Employment.setValue(data.is_employment, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.as_Input_Code.setValue("", true);
            this.as_Input_Description.setValue("", true);
            this.as_Input_Description_Multi_Lang.setValue({ entity: data, targetAttribute: "description" });
            
            this.as_Input_StatusGroup.loadListValues();
            //this.UiModder.domClass.add(this.as_Input_StatusGroup.scrollContainer, "w3-2018-coconut-milk");

            this.as_Input_BackgroundColor.value = "#ffffff";
            this.as_Input_TextColor.value = "#000000";
            this.as_Input_Order.setValue(null, true);

            //this.as_Checkbox_GeneratingAutoCostUnit.setValue(false, true);
            this.as_Checkbox_WithPublic.setValue(false, true);
            this.as_Checkbox_ToPublishInWeb.setValue(false, true);
            //this.as_Checkbox_ToPublishInEgo.setValue(false, true);
            this.as_Checkbox_Event.setValue(false, true);
            this.as_Checkbox_ImportToCommdoc.setValue(false, true);
            //this.as_Checkbox_Employment.setValue(false, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData(statusId);
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(statusId?: string): void {

        this.formData.code = this.as_Input_Code.getValue();

        //this.formData.description = this.as_Input_Description.getValue();

        this.as_Input_Description_Multi_Lang.getValueOntoEntity(this.formData as any);
        //this.formData.__multilang["description"] = this.as_Input_Description_Multi_Lang.getValue();


        console.log(this.as_Input_Description_Multi_Lang.getValue());

        statusId ? this.formData.ev_activity_status_group_id = statusId : this.formData.ev_activity_status_group_id = this.as_Input_StatusGroup.getValue();

        //this.formData.is_generating_auto_cost_unit = this.as_Checkbox_GeneratingAutoCostUnit.getValue();
        this.formData.is_with_public = this.as_Checkbox_WithPublic.getValue();
        this.formData.is_to_publish_in_web = this.as_Checkbox_ToPublishInWeb.getValue();
        //this.formData.is_to_publish_in_ego = this.as_Checkbox_ToPublishInEgo.getValue();
        this.formData.is_event = this.as_Checkbox_Event.getValue();
        this.formData.is_import_to_commdoc = this.as_Checkbox_ImportToCommdoc.getValue();
        //this.formData.is_employment = this.as_Checkbox_Employment.getValue();
        this.formData.order = this.as_Input_Order.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.as_Input_TextColor.value;
        let backHex = this.as_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }


    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.code) b = false;

        //if (!this.formData.description) b = false;

        if (!this.formData.ev_activity_status_group_id) {

            this.indicateErrorOnInput(this.as_Input_StatusGroup);
            b = false;
        }

        return b;
    }

    private _onChangeActivityStatusInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }



    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.EvActivityStatus;

        this.as_Input_Code.setMaxLength(20);
        this.as_Input_Description.setMaxLength(255);
        this.as_Input_StatusGroup.setOuterPlaceholder("MainCatalogsEditor_Placeholder_ActivityStatusGroup");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(ActivityStatusEditor.prototype, {
  as_Input_Code: () => (new Edit()),
  as_Input_Description: () => (new Edit()),
  as_Input_Description_Multi_Lang: () => (new MultiLangEdit()),
  as_Input_StatusGroup: () => (new SearchSelect()),
  as_Input_Order: () => (new NumberInput()),
  as_Checkbox_WithPublic: () => (new CheckBox()),
  as_Checkbox_ToPublishInWeb: () => (new CheckBox()),
  as_Checkbox_Event: () => (new CheckBox()),
  as_Checkbox_ImportToCommdoc: () => (new CheckBox()),
});
export default mdsWidget(ActivityStatusEditor);
